import React, { useState } from 'react';

// Comments on a Production Plan day (header of the Days zone): several people, several notes per day.
// Reuses the .ptp-comment-popup look from PlanToProducePage.css.
const fmt = ts => { const d = new Date(ts); return isNaN(d) ? '' : d.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }); };

const DayCommentsPopup = ({ day, comments, onPost, onDelete, onClose }) => {
  const [val, setVal] = useState('');
  const [busy, setBusy] = useState(false);
  const post = async () => {
    const text = val.trim();
    if (!text || busy) return;
    setBusy(true);
    try { await onPost(text); setVal(''); } finally { setBusy(false); }
  };
  return (
    <div className="ptp-comment-popup pp-dc">
      <div className="ptp-comment-popup-header">
        <span><i className="fas fa-comments" style={{ marginRight: 6 }} />{day}</span>
        <button className="ptp-comment-close" onClick={onClose}><i className="fas fa-times" /></button>
      </div>
      <div className="pp-dc__list">
        {comments.length === 0 && <div className="pp-dc__empty">No comments yet</div>}
        {comments.map(c => (
          <div key={c.id} className="pp-dc__item">
            <div className="pp-dc__meta">
              <b>{c.author || 'Unknown'}</b> · {fmt(c.created_at)}
              {c.mine && <button className="pp-dc__del" title="Delete my comment" onClick={() => onDelete(c.id)}><i className="fas fa-trash-alt" /></button>}
            </div>
            <div className="pp-dc__text">{c.text}</div>
          </div>
        ))}
      </div>
      <textarea className="ptp-comment-textarea" placeholder="Write a comment…" value={val} rows={2} autoFocus
        onChange={e => setVal(e.target.value)}
        onKeyDown={e => { if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) post(); }} />
      <div className="ptp-comment-actions">
        <button className="ptp-comment-save" disabled={!val.trim() || busy} onClick={post}>Post</button>
        <button className="ptp-comment-cancel" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default DayCommentsPopup;
